type AppIconProps = {
  name: string;
  size?: number;
  className?: string;
};

export function AppIcon({ name, size = 18, className }: AppIconProps) {
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        display: "block",
        width: size,
        height: size,
        flexShrink: 0,
        background: "currentColor",
        maskImage: `url(/emoji/${name}.svg)`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        WebkitMaskImage: `url(/emoji/${name}.svg)`,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
      }}
    />
  );
}
